import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
import {normalize} from "@/utils/data";

export default class Notification extends GenexLMSModel {
    static entity = 'notifications'

    static fields() {
        return {
            id: this.attr(null),
            type: this.attr(""),
            notifiable_type: this.attr(""),
            notifiable_id: this.attr(null),
            notifiable: this.morphTo('notifiable_id', 'notifiable_type'),
            data: this.attr(""),
            read_at: this.attr(""),
            created_at: this.attr(""),
            updated_at: this.attr(""),

        }
    }

    static FetchAll(userId, {page = 1, limit = 15}, query = {}, relationships = []) {
        return this.api().get(`/users/${userId}/notifications`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {
                    ...{
                        page: page, limit: limit, with: relationships
                    }, ...(query !== {} ? query : {}),
                },
                dataTransformer: ({data: {data}}) => {
                    return GenexHelperMixins.methods.NormalizeRecursive(data);
                },
            }
        )
    }

    static FetchAllCount(userId) {
        return this.api().get(`/users/${userId}/notifications/unread-count`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
                params: {},
            }
        )
    }

    static FetchById(id, relationships = [], moduleOverrideKeys= null) {
        return this.apiWithHeaders().get(`assessments/${id}`, {
            params: {
                ...{
                    with: relationships,
                },
            },
            dataTransformer: ({ data: { data } }) => {
                if(moduleOverrideKeys){
                    let normalData = normalize(data);
                    return {...normalData, ...moduleOverrideKeys}
                }
                return normalize(data);
            },
        });
    }

    static MarkAsReadById(userId, notificationId) {
        return this.apiWithHeaders().patch(`/users/${userId}/notifications/${notificationId}/read`, {}, {
            dataTransformer: ({ data: { data } }) => {
                return normalize(data);
            },
            save: true,
        });
    }

    static MarkAllAsRead(userId) {
        return this.apiWithHeaders().patch(`/users/${userId}/notifications/read`, {}, {
            dataTransformer: ({ data: { data } }) => {
                return normalize(data);
            },
            save: true,
        });
    }

}
